import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';
import AddToCartIcon from 'web-ui-kit/assets/AddToCartIcon';
import { primaryM, grayLightM, selectedLightM } from 'web-ui-kit/colors';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2, _templateObject3;
/**
 * Add to cart button with hover, pressed, and disabled states.
 */


function AddToCartButton(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$iconColor = _ref.iconColor,
      iconColor = _ref$iconColor === void 0 ? primaryM : _ref$iconColor,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function (jsEvent) {} : _ref$onClick;

  var handleClick = function handleClick(jsEvent) {
    jsEvent.stopPropagation();

    if (!disabled) {
      onClick(jsEvent);
    }
  };

  var Button = styles.Button;
  return (
    /*#__PURE__*/
    React.createElement(Button, {
      className: className,
      isDisabled: disabled,
      onClick: handleClick
    },
    /*#__PURE__*/
    React.createElement(AddToCartIcon, {
      iconColor: iconColor,
      variant: disabled ? 'disabled' : 'filled'
    }))
  );
}

AddToCartButton.propTypes = {
  /** Allows extending styles with styled(AddToCartButton) constructor */
  className: PropTypes.string,

  /** Whether or not the button is currently disabled */
  disabled: PropTypes.bool,

  /** For reporting click events up to parent */
  onClick: PropTypes.func
};
/**
 * Styles.
 */

var styles = {
  Button: styled.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    height: 2.125rem;\n    width: 2.125rem;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    appearance: none;\n    background-color: transparent;\n    border: none;\n    border-radius: 50%;\n    cursor: pointer;\n    outline: none;\n    padding: 0;\n    overflow: hidden;\n    transition: all 300ms;\n\n    ", "\n  "])), function (p) {
    return p.isDisabled ? css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      cursor: auto;\n    "]))) : css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      @media (hover: hover) {\n        &:hover {\n          background-color: ", ";\n        }\n      }\n      &:active {\n        background-color: ", ";\n      }\n    "])), grayLightM, selectedLightM);
  })
};
export default AddToCartButton;